module.exports = __webpack_public_path__ + "img/ae.dfeb0f94.svg";